export enum CompanyDetailsEvents {
  ManageNetworkChange = 'canManageNetworksChange',
  ManageByAboveChange = 'canBeManagedByAboveChange',
  CompanyTypeChange = 'companyTypeChange',
}

export class OnManageByAboveChange extends CustomEvent<{ canBeManagedByAbove: boolean }> {
  constructor(canBeManagedByAbove: boolean) {
    super(CompanyDetailsEvents.ManageByAboveChange, {
      detail: {
        canBeManagedByAbove,
      },
      bubbles: true,
      composed: true,
    });
  }
}
